/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated from: permissions.schema.yaml
 * Last updated: 2026-01-25T17:34:40.898Z
 * 
 * This file is automatically generated. Any manual changes will be overwritten.
 */

// Rollen-Definitionen
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  ARZT: 'arzt',
  ASSISTENT: 'assistent',
  REZEPTION: 'rezeption',
  BILLING: 'billing',
  PATIENT: 'patient',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

// Actions (Operationen)
export const ACTIONS = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
  WRITE: 'write',
  BOOK: 'book',
  CANCEL: 'cancel',
  RESCHEDULE: 'reschedule',
  GENERATE: 'generate',
  PRINT: 'print',
  SHARE: 'share',
  EXPORT: 'export',
  IMPORT: 'import',
  APPROVE: 'approve',
  REJECT: 'reject',
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',
  AUDIT: 'audit',
  CONFIGURE: 'configure',
  MANAGE_USERS: 'manage_users',
  MANAGE_ROLES: 'manage_roles',
  MANAGE_PERMISSIONS: 'manage_permissions',
  MANAGE_STAFF: 'manage_staff',
  DIAGNOSE: 'diagnose',
  PRESCRIBE: 'prescribe',
  TREAT: 'treat',
  REFER: 'refer',
  DISCHARGE: 'discharge',
  QUERY: 'query',
  RETRIEVE: 'retrieve',
  DEPRECATE: 'deprecate',
  SUBMIT: 'submit',
} as const;

export type Action = typeof ACTIONS[keyof typeof ACTIONS];

// Resources (Ressourcen-Typen)
export const RESOURCES = {
  PATIENT: 'patient',
  APPOINTMENT: 'appointment',
  DOCUMENT: 'document',
  DIAGNOSIS: 'diagnosis',
  PRESCRIPTION: 'prescription',
  BILLING: 'billing',
  USER: 'user',
  ROLE: 'role',
  LOCATION: 'location',
  SERVICE: 'service',
  TEMPLATE: 'template',
  STAFF: 'staff',
  AUDIT_LOG: 'audit_log',
  SYSTEM: 'system',
  INVENTORY: 'inventory',
  SETTINGS: 'settings',
  SECURITY: 'security',
  REPORTS: 'reports',
  AUDIT: 'audit',
  XDS_DOCUMENT: 'xds_document',
  XDS_SUBMISSION_SET: 'xds_submission_set',
  XDS_FOLDER: 'xds_folder',
  XDS_ASSOCIATION: 'xds_association',
} as const;

export type Resource = typeof RESOURCES[keyof typeof RESOURCES];

// Standard-Permissions für jede Rolle
export const ROLE_PERMISSIONS: Record<Role, Partial<Record<Resource, readonly Action[]>> & { '*'?: readonly ['*'] }> = {
  [ROLES.SUPER_ADMIN]: {
    '*': ['*'] as const
  },
  [ROLES.ADMIN]: {
    [RESOURCES.PATIENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
    [RESOURCES.APPOINTMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.BOOK, ACTIONS.CANCEL, ACTIONS.RESCHEDULE] as const,
    [RESOURCES.DOCUMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.GENERATE, ACTIONS.PRINT, ACTIONS.SHARE, ACTIONS.EXPORT] as const,
    [RESOURCES.DIAGNOSIS]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.DIAGNOSE] as const,
    [RESOURCES.PRESCRIPTION]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.PRESCRIBE] as const,
    [RESOURCES.BILLING]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.GENERATE, ACTIONS.PRINT] as const,
    [RESOURCES.USER]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.MANAGE_USERS] as const,
    [RESOURCES.ROLE]: [ACTIONS.READ, ACTIONS.MANAGE_ROLES] as const,
    [RESOURCES.LOCATION]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
    [RESOURCES.SERVICE]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
    [RESOURCES.TEMPLATE]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
    [RESOURCES.STAFF]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.MANAGE_STAFF] as const,
    [RESOURCES.AUDIT_LOG]: [ACTIONS.READ, ACTIONS.AUDIT] as const,
    [RESOURCES.SYSTEM]: [ACTIONS.CONFIGURE] as const,
    [RESOURCES.SETTINGS]: [ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.CONFIGURE] as const,
    [RESOURCES.SECURITY]: [ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.CONFIGURE] as const,
    [RESOURCES.REPORTS]: [ACTIONS.READ, ACTIONS.GENERATE, ACTIONS.EXPORT] as const,
    [RESOURCES.AUDIT]: [ACTIONS.READ, ACTIONS.AUDIT] as const,
    [RESOURCES.XDS_DOCUMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.QUERY, ACTIONS.RETRIEVE, ACTIONS.DEPRECATE, ACTIONS.SUBMIT] as const,
    [RESOURCES.XDS_SUBMISSION_SET]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
    [RESOURCES.XDS_FOLDER]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
    [RESOURCES.XDS_ASSOCIATION]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE] as const,
  },
  [ROLES.ARZT]: {
    [RESOURCES.PATIENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE] as const,
    [RESOURCES.APPOINTMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.BOOK, ACTIONS.CANCEL, ACTIONS.RESCHEDULE] as const,
    [RESOURCES.DOCUMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.GENERATE, ACTIONS.PRINT, ACTIONS.SHARE] as const,
    [RESOURCES.DIAGNOSIS]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.DIAGNOSE] as const,
    [RESOURCES.PRESCRIPTION]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.PRESCRIBE] as const,
    [RESOURCES.BILLING]: [ACTIONS.READ, ACTIONS.GENERATE] as const,
    [RESOURCES.LOCATION]: [ACTIONS.READ] as const,
    [RESOURCES.SERVICE]: [ACTIONS.READ] as const,
    [RESOURCES.STAFF]: [ACTIONS.READ] as const,
    [RESOURCES.TEMPLATE]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE] as const,
    [RESOURCES.REPORTS]: [ACTIONS.READ, ACTIONS.GENERATE] as const,
    [RESOURCES.SETTINGS]: [ACTIONS.READ] as const,
    [RESOURCES.SECURITY]: [ACTIONS.READ] as const,
    [RESOURCES.XDS_DOCUMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.QUERY, ACTIONS.RETRIEVE, ACTIONS.DEPRECATE] as const,
    [RESOURCES.XDS_SUBMISSION_SET]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE] as const,
    [RESOURCES.XDS_FOLDER]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE] as const,
  },
  [ROLES.ASSISTENT]: {
    [RESOURCES.PATIENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE] as const,
    [RESOURCES.APPOINTMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.BOOK, ACTIONS.CANCEL, ACTIONS.RESCHEDULE] as const,
    [RESOURCES.DOCUMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.GENERATE, ACTIONS.PRINT] as const,
    [RESOURCES.DIAGNOSIS]: [ACTIONS.READ] as const,
    [RESOURCES.PRESCRIPTION]: [ACTIONS.READ] as const,
    [RESOURCES.BILLING]: [ACTIONS.READ] as const,
    [RESOURCES.LOCATION]: [ACTIONS.READ] as const,
    [RESOURCES.SERVICE]: [ACTIONS.READ] as const,
    [RESOURCES.STAFF]: [ACTIONS.READ] as const,
    [RESOURCES.TEMPLATE]: [ACTIONS.READ] as const,
    [RESOURCES.REPORTS]: [ACTIONS.READ] as const,
    [RESOURCES.SETTINGS]: [ACTIONS.READ] as const,
    [RESOURCES.SECURITY]: [ACTIONS.READ] as const,
    [RESOURCES.XDS_DOCUMENT]: [ACTIONS.READ, ACTIONS.QUERY, ACTIONS.RETRIEVE] as const,
    [RESOURCES.XDS_SUBMISSION_SET]: [ACTIONS.READ] as const,
    [RESOURCES.XDS_FOLDER]: [ACTIONS.READ] as const,
  },
  [ROLES.REZEPTION]: {
    [RESOURCES.PATIENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE] as const,
    [RESOURCES.APPOINTMENT]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.BOOK, ACTIONS.CANCEL, ACTIONS.RESCHEDULE] as const,
    [RESOURCES.DOCUMENT]: [ACTIONS.READ, ACTIONS.PRINT] as const,
    [RESOURCES.BILLING]: [ACTIONS.READ, ACTIONS.GENERATE, ACTIONS.PRINT] as const,
    [RESOURCES.LOCATION]: [ACTIONS.READ] as const,
    [RESOURCES.SERVICE]: [ACTIONS.READ] as const,
    [RESOURCES.REPORTS]: [ACTIONS.READ] as const,
    [RESOURCES.SETTINGS]: [ACTIONS.READ] as const,
    [RESOURCES.SECURITY]: [ACTIONS.READ] as const,
  },
  [ROLES.BILLING]: {
    [RESOURCES.PATIENT]: [ACTIONS.READ] as const,
    [RESOURCES.APPOINTMENT]: [ACTIONS.READ] as const,
    [RESOURCES.DOCUMENT]: [ACTIONS.READ, ACTIONS.PRINT] as const,
    [RESOURCES.BILLING]: [ACTIONS.CREATE, ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.GENERATE, ACTIONS.PRINT, ACTIONS.EXPORT] as const,
    [RESOURCES.LOCATION]: [ACTIONS.READ] as const,
    [RESOURCES.SERVICE]: [ACTIONS.READ] as const,
    [RESOURCES.REPORTS]: [ACTIONS.READ, ACTIONS.GENERATE, ACTIONS.EXPORT] as const,
    [RESOURCES.SETTINGS]: [ACTIONS.READ] as const,
    [RESOURCES.SECURITY]: [ACTIONS.READ] as const,
  },
  [ROLES.PATIENT]: {
    [RESOURCES.PATIENT]: [ACTIONS.READ] as const,
    [RESOURCES.APPOINTMENT]: [ACTIONS.READ, ACTIONS.BOOK, ACTIONS.CANCEL] as const,
    [RESOURCES.DOCUMENT]: [ACTIONS.READ] as const,
    [RESOURCES.BILLING]: [ACTIONS.READ] as const,
    [RESOURCES.REPORTS]: [ACTIONS.READ] as const,
  },
} as const;

// Rollen-Hierarchie
export const ROLE_HIERARCHY: Record<Role, readonly Role[]> = {
  [ROLES.SUPER_ADMIN]: [ROLES.ADMIN, ROLES.ARZT, ROLES.ASSISTENT, ROLES.REZEPTION, ROLES.BILLING, ROLES.PATIENT] as const,
  [ROLES.ADMIN]: [ROLES.ARZT, ROLES.ASSISTENT, ROLES.REZEPTION, ROLES.BILLING, ROLES.PATIENT] as const,
  [ROLES.ARZT]: [ROLES.ASSISTENT, ROLES.REZEPTION, ROLES.BILLING, ROLES.PATIENT] as const,
  [ROLES.ASSISTENT]: [ROLES.REZEPTION, ROLES.BILLING, ROLES.PATIENT] as const,
  [ROLES.REZEPTION]: [ROLES.PATIENT] as const,
  [ROLES.BILLING]: [ROLES.PATIENT] as const,
  [ROLES.PATIENT]: [] as const,
} as const;

// Helper Types
export type Permission = `${Resource}.${Action}`;

export interface RoleInfo {
  role: Role;
  label: string;
  description: string;
  level: number;
}

export const ROLE_INFO: Record<Role, RoleInfo> = {
  [ROLES.SUPER_ADMIN]: {
    role: ROLES.SUPER_ADMIN,
    label: 'Super Administrator',
    description: 'Vollzugriff auf alle Systemfunktionen und -einstellungen',
    level: 6,
  },
  [ROLES.ADMIN]: {
    role: ROLES.ADMIN,
    label: 'Administrator',
    description: 'Verwaltung der Ordination und Benutzer',
    level: 5,
  },
  [ROLES.ARZT]: {
    role: ROLES.ARZT,
    label: 'Arzt',
    description: 'Medizinische Behandlung und Patientenverwaltung',
    level: 4,
  },
  [ROLES.ASSISTENT]: {
    role: ROLES.ASSISTENT,
    label: 'Medizinische Assistenz',
    description: 'Unterstützung bei der Patientenbetreuung',
    level: 3,
  },
  [ROLES.REZEPTION]: {
    role: ROLES.REZEPTION,
    label: 'Rezeption',
    description: 'Terminverwaltung und Patientenaufnahme',
    level: 2,
  },
  [ROLES.BILLING]: {
    role: ROLES.BILLING,
    label: 'Abrechnung',
    description: 'Abrechnung und Finanzverwaltung',
    level: 2,
  },
  [ROLES.PATIENT]: {
    role: ROLES.PATIENT,
    label: 'Patient',
    description: 'Eigene Daten einsehen und Termine buchen',
    level: 1,
  },
} as const;

const permissions = {
  ROLES,
  ACTIONS,
  RESOURCES,
  ROLE_PERMISSIONS,
  ROLE_HIERARCHY,
  ROLE_INFO,
};

export default permissions;
